module.exports = __webpack_public_path__ + "img/03.08fd119a.png";